import { ApiResponse, HTTPVerb } from '../Modules/Utils/API/Interfaces/IApi';
import { ApiManager } from '../Modules/Utils/API/ApiManager';

enum APIConstants {
    GetServiceProductPackageDataAuthenticated = '/api/OpenServiceProductPackage/',
}

export interface IOpenServiceProductPackageDataRequest {
    SubBrandId: number;
    ProductPackageId: number;
    AdditionalActivationParameters?: string;
}

export interface IGetServiceProductPackageDataAuthenticatedResponse {
    MessagesDetails?: string;
    ErrorCode?: number;
    ErrorDescription?: string;
    IsOk: boolean;
}

export default class ServiceProductPackageApi {
    public static GetServiceProductPackageDataAuthenticated = async (
        data: IOpenServiceProductPackageDataRequest,
    ): Promise<ApiResponse<IGetServiceProductPackageDataAuthenticatedResponse>> => {
        return ApiManager.getAPIInstance().authenticatedRequest({
            url: APIConstants.GetServiceProductPackageDataAuthenticated,
            method: HTTPVerb.POST,
            data,
        });
    };
}
